import React from 'react';
import {connect} from 'react-redux';
import "bootstrap/dist/css/bootstrap.min.css";
import UploadImage from "../../components/file-upload/image-upload.component";

const LogoAndStampTab = (props) => {
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>
            <UploadImage
                fileId={props.company.address.fileLogoId}
                entityId={props.company.id}
                description='Logo'
                cardActive={props.isActive}
            />
             <UploadImage
                fileId={props.company.address.fileStampId}
                entityId={props.company.id}
                description='Stamp'
                cardActive={props.isActive}
            />
        </div>
    );
};


const mapStateToProps = (state) => ({
    company: state.company.currentCompany
 });
 
 export default connect(mapStateToProps,null)(LogoAndStampTab);